
import moment from 'moment';
import ApiService from '@/services/settings-service.js';

export default {
  filters: {
    formatYear(date) {
      return moment(date).format('YYYY');
    },
  },
  props: {
    value: Boolean,
    updateValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      date: null,
      menu: false,
      isAdd: false,
      // 3333
      id: '',
      driverId: '',
      driverDefault: '',
      name: '',
      driverCode: '',
      department: '',
      phoneHome: '',
      phoneMobile: '',
      phoneOffice: '',
      // test
      departmentOption: [],
      checkDepartmentOption: [],
      filterInput: '',
      filterTypeInput: '',
      rules: {
        required: (value) => !!value || this.$t('Required'),
      },
    };
  },
  computed: {
    Active() {
      return [
        { text: this.$t('Setting.Active'), value: true },
        { text: this.$t('Setting.Inactive'), value: false },
      ];
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
    show(val) {
      this.$refs.form.resetValidation();
      this.id = '';
      this.driverId = '';
      this.driverDefault = '';
      this.name = '';
      this.driverCode = '';
      this.department = '';
      // this.phoneHome = '';
      this.phoneMobile = '';
      this.date = '';
      // this.phone;Office = '';
      if (val) {
        if (Object.keys(this.updateValue).length === 0) {
          this.isAdd = true;
        } else {
          console.log(this.updateValue);
          this.id = this.updateValue.id;
          this.driverId = this.updateValue.externalDriverId;
          this.driverDefault = this.updateValue.default;
          this.name = this.updateValue.name;
          this.date = this.updateValue.bod
            ? moment(this.updateValue.bod).format('YYYY-MM-DD')
            : '';
          this.driverCode = this.updateValue.code;
          this.department = this.updateValue.companyGroupId;
          // this.phoneHome = this.updateValue.phoneHome;
          this.phoneMobile = this.updateValue.mobile;
          // this.phoneOffice = this.updateValue.phoneOffice;
        }
        this.getCompanyGroups();
      } else {
        this.isAdd = false;
        this.$emit('clearUpdateValue');
      }
    },
    filterInput(value) {
      this.departmentOption = this.checkDepartmentOption;
      this.departmentOption = this.departmentOption.filter((post) => {
        return post.text.toLowerCase().trim().includes(value.toLowerCase());
      });
    },
  },
  mounted() {
    // this.getCompanyGroups();
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
    getCompanyGroups() {
      ApiService.getCompanyGroups(this.$axios)
        .then((response) => {
          this.departmentOption = response.items.map((element) => ({
            text: element.name,
            value: element.id,
          }));
          /*
          response.items.forEach((element) => {
            this.departmentOption.push({
              text: element.name,
              value: element.id,
            });
          });
          */
        })
        .catch({});
      this.checkDepartmentOption = this.departmentOption;
    },
    submit() {
      if (this.$refs.form.validate()) {
        const query = {
          name: this.name,
          code: this.driverCode,
          companyGroupId: this.department ? this.department : null,
          mobile: this.phoneMobile,
          // dob: this.date,
          bod: this.date || null,
        };
        if (this.isAdd) {
          console.log('add');
          console.log(query);
          ApiService.addDrivers(this.$axios, query)
            .then((response) => {
              if (response.success) {
                this.show = false;
              }
              this.$emit('forceRerenderOnSubmit', response);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log('update');
          query.id = this.id;
          console.log(query);
          ApiService.updateDrivers(this.$axios, query)
            .then((response) => {
              if (response.success) {
                this.show = false;
              }
              this.$emit('forceRerenderOnSubmit', response);
            })
            .catch((error) => {
              console.log(error);
            });
        }
        // this.$emit('forceRerenderOnSubmit');
        this.show = false;
      }
    },
  },
};
